import Vue from 'vue';
import Router from 'vue-router';

import _import from './_import';

import Layout from '@/layouts';

Vue.use(Router);

// 页面的一些信息可以写在meta
// meta的auth不为空，表示该页面需要权限认证
// auth为假或者不存在meta则表示该页面用户可访问

const globalRouter = [
  {
    path: '/login',
    name: 'login',
    component: _import('_global/login')
  },
  {
    path: '/error',
    name: 'error',
    component: _import('_global/error_404')
  },
  {
    path: '*',
    redirect: '/error'
  },
  {
    path: '',
    component: Layout,
    redirect: '/_list/company',
    children: [
      {
        path: '/home',
        name: 'home',
        component: _import('_global/home'),
        redirect: '/_list/company'
      }
    ]
  }
];

const examplePages = {
    path: '/example',
    name: 'example',
    component: Layout,
    redirect: '/example/module',
    hidden: true,
    meta: {
      title: '案例',
      icon: 'people'
    },
    children: [
      {
        path: 'module',
        name: 'module',
        component: _import('_example/module'),
        meta: {
          title: '弹窗式'
        }
      },
      {
        path: 'module2',
        name: 'module2',
        component: _import('_example/module2'),
        meta: {
          title: '页面式'
        }
      },
      {
        path: 'module2/new',
        name: 'module2Add',
        hidden: true,
        component: _import('_example/module2/module2Add'),
        meta: {
          title: '页面式'
        }
      },
      {
        path: 'module2/:id',
        name: 'module2Details',
        hidden: true,
        component: _import('_example/module2/module2Details'),
        meta: {
          title: '页面式'
        }
      }
    ]
  };

const firstPages = {
  path: '/_list',
  name: '_list',
  component: Layout,
  redirect: '/_list/company',
  meta: {
    title: '官网信息',
    icon: '_list'
  },
  children: [
    {
      path: 'news',
      name: 'news',
      component: _import('_list/news/index'),
      meta: {
        title: '公司新闻'
      }
    },
    {
      path: 'company',
      name: 'company',
      component: _import('_list/company'),
      meta: {
        title: '商家入驻信息'
      }
    },
    {
      path: 'user',
      name: 'user',
      component: _import('_list/user/index'),
      meta: {
        title: '批发商信息'
      }
    },
    {
      path: 'news/add',
      name: 'newsadd',
      component: _import('_list/news/newsadd'),
      hidden: true,
      meta: {
        title: '添加新闻'
      }
    },
    {
      path: 'news/add',
      name: 'newsadd',
      component: _import('_list/news/newsadd'),
      hidden: true,
      meta: {
        title: '添加新闻'
      }
    },
    {
      path: 'news/:id',
      name: 'newsDetails',
      hidden: true,
      component: _import('_list/news/newsdetail'),
      meta: {
        title: '新闻详情'
      }
    },
    {
      path: 'news/update/:id',
      name: 'newsUpdate',
      hidden: true,
      component: _import('_list/news/newsadd'),
      meta: {
        title: '编辑新闻'
      }
    },
    {
      path: 'cloudfactory',
      name: 'cloudfactory',
      component: _import('_list/cloudFactory/cloudfactory'),
      meta: {
        title: '云工厂招商'
      }
    },
    {
      path: 'cloudfactory/:id',
      name: 'cloudfactorydetail',
      hidden: true,
      component: _import('_list/cloudFactory/cloudfactorydetail'),
      meta: {
        title: '云工厂招商详情'
      }
    },
    {
      path: 'customer_information',
      name: 'customer',
      component: _import('_list/customer/index'),
      meta: {
        title: '深铺客户线索'
      }
    }
  ]
};

const pageRouter = [
  examplePages,
  firstPages
];

const routerMap = [...globalRouter, ...pageRouter];

export { pageRouter };

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ x: 0, y: 0 }), // 页面滚动到顶部
  routes: routerMap
});
